import type { GlobalLocales } from '../types';

const global: GlobalLocales = {
  account: 'Account',
  accountSettings: 'Account Instellingen',
  archive: 'Archief',
  assigned: 'Toegewezen',
  assignments: 'Opdrachten',
  availability: 'Beschikbaarheid',
  available: 'Beschikbaar',
  blocked: 'Geblokkeerd',
  cancel: 'Annuleren',
  checkProfile: 'Bekijk profiel',
  clear: 'Wissen',
  clickHere: 'Klik hier',
  close: 'Sluiten',
  competence: 'Competentie',
  confirm: 'Bevestigen',
  confirmAction: 'Bevestig actie',
  continue: 'Doorgaan',
  dashboard: 'Dashboard',
  date: 'Datum',
  details: 'Gegevens',
  disabled: 'Gehandicapt',
  done: 'Gedaan',
  email: 'Email',
  emailInvalidErrorMessage: 'email is ongeldig',
  endTime: 'End Tijd',
  error: 'foutmelding',
  export: 'Exporteren',
  favorites: 'Favorieten',
  fieldMustBePositiveMessage: 'Dit veld moet positief zijn',
  fieldRequiredErrorMessage: 'Dit veld is verplicht',
  freelancer: 'Freelancer',
  freelancers: 'Freelancers',
  goBack: 'Ga terug',
  help: 'Helpen',
  home: 'Home',
  hourlyRate: 'Uurtarief',
  hourlyRates: 'Uurtarieven',
  instructions: 'Instructies',
  integrations: 'Integraties',
  interest: 'Keuze',
  invoices: 'Facturen',
  loading: 'bezig met laden',
  location: 'Vestiging',
  locations: 'Vestigingen',
  login: 'Inloggen',
  logout: 'Uitloggen',
  maxLengthFieldError: {
    other: 'Maximale lengte: %{count}',
  },
  minLengthFieldError: {
    other: 'Minimale lengte: %{count}',
  },
  minLengthPasswordErrorMessage: 'wachtwoord is te kort!',
  minute: {
    one: '1 minuut',
    other: '%{count} minuten',
    zero: '0 minuut',
  },
  mode: 'Modus',
  mustAgree: 'U moet akkoord gaan met de algemene voorwaarden!',
  navigateToDashboard: 'Navigeer naar de dashboard',
  navigateToHomePage: 'Navigeer naar de startpagina',
  navigateToOrganisationSettingsPage: 'Navigeer naar instellingen',
  navigateToPlannerPage: 'Navigeer naar de plannerpagina',
  NB: 'Let op!',
  next: 'Volgende',
  nextStep: 'Volgende stap',
  no: 'Nee',
  noResultsFound: 'We konden geen resultaten voor je vinden.',
  noResultsFoundShort: 'Geen resultaten gevonden',
  notification: 'notificatie',
  notifications: 'Notificaties',
  numberTypeError: 'Dit veld mag alleen cijfers bevatten',
  open: 'Open',
  organisation: 'Organisatie',
  organisationSettings: 'Organisatie Instellingen',
  pageDidntLoad: 'Oeps, deze pagina laadde niet',
  password: 'Wachtwoord',
  passwordConfirmation: 'Wachtwoord Bevestigen',
  PasswordConstraintErrorMessage:
    'Wachtwoord moet letters en cijfers bevatten!',
  passwordsMustMatchErrorMessage: 'Wachtwoorden moeten overeenkomen!',
  pause: 'Pauze',
  periodJobs: 'Langere opdrachten',
  personal: 'Persoonlijk',
  phoneNumberInvalidErrorMessage:
    'Geef een geldig telefoonnummer op. bijvoorbeeld "0612345678".',
  placeACall: 'Een oproep plaatsen',
  planner: 'Planner',
  planners: 'Planners',
  postalCodeInvalidErrorMessage: 'Geef een geldige postcode op.',
  previous: 'Vorige',
  readInstructions: 'Lees instructies',
  readInstructionsTooltip:
    'Klik hier om instructies te lezen voor een bepaalde stap',
  ReloadPage: 'Herlaad pagina',
  retry: 'Opnieuw proberen',
  save: 'Opslaan',
  saveAndContinue: 'Opslaan en doorgaan',
  settings: 'Instellingen',
  signUp: 'Aanmelden',
  skipStep: 'Stap overslaan',
  somethingWentWrong: 'Er is iets fout gegaan',
  sorryPageDidntLoadTryAgain:
    'We konden deze pagina helaas niet laaden. Probeer het later opnieuw',
  staff: 'Intern',
  start: 'Start',
  startTime: 'Start Tijd',
  termsAndConditions: 'algemene voorwaarden',
  time: 'Tijd',
  toAsk: 'Vragen',
  toCallToAction: 'Oproepen',
  toInvite: 'Uitnodigen',
  unknownError:
    'Er is een onbekende fout opgetreden, probeer het later opnieuw.',
  urgent: 'Spoed',
  userName: 'Gebruikersnaam',
  users: 'Gebruikers',
  vacancies: 'Vacatures',
  watchVideoInstructions: 'Bekijk instructiefilmpje',
  watchVideoInstructionsTooltip: 'Klik hier om terug te gaan naar de video',
  yes: 'Ja',
};

export default global;
